export default {
    cinders: {
        // 20 days
        start: '01-15',
        end: '02-03',
        color: 'amber',
        currency: 'wax',
        token: 'cindersToken'
    },
    bloom: {
        // 23 days
        start: '03-09',
        end: '03-31',
        color: 'light-green',
        currency: 'humus',
        token: 'bloomToken'
    },
    weatherChaos: {
        // 18 days
        start: '05-22',
        end: '06-08',
        color: 'grey',
        currency: 'cloud',
        token: 'weatherChaosToken'
    },
    summerFestival: {
        // 28 days
        start: '07-26',
        end: '08-22',
        color: 'orange-red',
        currency: 'cocktail',
        token: 'summerFestivalToken'
    },
    nightHunt: {
        // 16 days
        start: '10-04',
        end: '10-19',
        color: 'deep-purple',
        currency: 'magic',
        token: 'nightHuntToken'
    },
    snowdown: {
        // 21 days
        start: '11-25',
        end: '12-15',
        color: 'skyblue',
        currency: 'snowball',
        token: 'snowdownToken'
    }
}
